module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAABGdBTUEAALGPC/xhBQAAATpJREFUKBWdUTFLw0AU7l3TTEFFqkspCLoF3JxcuzkG8mfEyaGb4A/oHFqySEL8BY66ZROHSkG3DgmXhPTid5J3HNKW4MHxvXzf+96798J67YmiaCiEeGCMjYn7i9BePM+7AzZK45RQFMXVPqPKa5rmOgiCU/JoM4g+kfvQwiFdB6j6wTlfkLALkZeRxsIwvJRSTkB06twaheM4cwvGe8x6QNW6YpZlx/w/RtUAIx6aC+vaVOfphbWMwBhfWjUCdFI7GeHq3Zjm57quF/gTZ4bHDDfQP6HfgrxQwq8Z65e2bQfAGbiBErYdGN/xghleN8XtcRjesLQ1qg6BO42qGHLPq6qisV4ZiH4cx6OyLI8QP27rSBz02nXdmzRNT3zfX1notoG4TJLkO8/zFLFLySbCKPH9BHMFXCntB3ipe9AcCQ3HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/List/icon-printer-gray.png
// module id = 1475
// module chunks = 0